import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../service.service';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';

@Component({
  selector: 'app-alqousbm-market-study',
  templateUrl: './alqousbm-market-study.component.html',
  styleUrls: ['./alqousbm-market-study.component.css']
})
export class AlqousbmMarketStudyComponent implements OnInit {

  isLoader = false
  body = true
  output:any = []
  space = " "

  constructor(private service:ServiceService) { }

  baseUrl = this.service.ReturnBase()

  //----------function for excel------------//
  excelExport() {
    var orderTable = document.getElementById('MarketStudy');
    var wb = XLSX.utils.table_to_book(orderTable, { sheet: "sheet1" });

    return XLSX.writeFile(wb, ('Alq Market Study Report.' + ('xlsx')));


  }

  ngOnInit(): void {
    this.service.viewAqouzbmmarketstudy().subscribe((res)=>{
     this.output = res.data
     console.log("data=",res);
     
    })
  }

}
